import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const fetchSecurityDeposits = createAsyncThunk(
  "security/fetchList",
  async ({ type = "application", page = 1, limit = 100, userid = 1 }) => {
    const body = new FormData();
    body.append("action", "customers");
    body.append("userid", userid);
    body.append("page", page);
    body.append("limit", limit);
    body.append("type", type); // "application" or "paid"

    const response = await fetch(baseUrl + "security_deposit_refills.php", {
      method: "POST",
      body,
    });
    const res = await response.json();
    return res;
  }
);

export const fetchSecurityDepositDetails = createAsyncThunk(
  "security/fetchDetails",
  async ({ userid, orderid }) => {
    const body = new FormData();
    body.append("action", "orders");
    body.append("userid", userid);
    body.append("orderid", orderid);

    const response = await fetch(baseUrl + "security_deposit_refills.php", {
      method: "POST",
      body,
    });
    const res = await response.json();
    return res;
  }
);

const initialState = {
  customerlist: [],
  customerDetails: [],
  loading: false,
  detailsLoading: false,
  currentType: "application", // Track current tab type
};

const depositListSlice = createSlice({
  name: "security",
  initialState,
  reducers: {
    setCurrentType: (state, action) => {
      state.currentType = action.payload;
    },
    clearCustomerDetails: (state) => {
      state.customerDetails = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSecurityDeposits.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSecurityDeposits.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchSecurityDeposits.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload;
        if (data.success) {
          state.customerlist = data || [];
        } else {
          state.customerlist = [];
        }
      })
      .addCase(fetchSecurityDepositDetails.pending, (state) => {
        state.detailsLoading = true;
      })
      .addCase(fetchSecurityDepositDetails.rejected, (state) => {
        state.detailsLoading = false;
      })
      .addCase(fetchSecurityDepositDetails.fulfilled, (state, action) => {
        state.detailsLoading = false;
        const data = action.payload;
        if (data.success) {
          state.customerDetails = data || [];
        } else {
          state.customerDetails = [];
        }
      });
  },
});

export const { setCurrentType, clearCustomerDetails } = depositListSlice.actions;
export default depositListSlice.reducer;